import { subApplicants } from "./sub-applicant-data";

export const applicants = [
  {
    id: 1,
    name: "Andrew Allen",
    first_name: "Andrew",
    last_name: "Allen",
    email: 'andrew@approveshield.com',
    phone: '555-555-5555',
    unit_rent: 3898,
    autoscore: "pass",
    created_at: "Nov 15, 2023",
    authorized_at: "Nov 16, 2023",
    docs_received_at: "Nov 17, 2023",
    completed_at: "Nov 18, 2023",
    sub_applicants: subApplicants,
    community: {
      id: 1,
      name: "Alista",
    },
    status: "Completed",
    screening_type: "Standard",
    
  },
  {
    id: 2,
    name: "Devery Channell",
    first_name: "Devery",
    last_name: "Channell",
    community: {
      id: 2,
      name: "Alista",
    },
    status: "Completed",
    screening_type: "Standard",
    autoscore: "conditional",
    created: "Nov 15, 2023",
  },
  {
    id: 3,
    name: "Daniel Ramirez",
    first_name: "Daniel",
    last_name: "Ramirez",
    community: {
      id: 3,
      name: "Alista",
    },
    status: "Completed",
    screening_type: "Standard",
    autoscore: "",
    created: "Nov 15, 2023",
  },
  {
    id: 4,
    name: "Lukas M",
    first_name: "Lukas",
    last_name: "M",
    community: {
      id: 4,
      name: "Alista",
    },
    status: "Completed",
    screening_type: "Standard",
    autoscore: "pass",
    created: "Nov 15, 2023",
  },
  {
    id: 5,
    name: "Elise Shultze",
    first_name: "Elise",
    last_name: "Shultze",
    community: {
      id: 5,
      name: "Alista",
    },
    status: "Completed",
    screening_type: "Standard",
    autoscore: "conditional",
    created: "Nov 15, 2023",
  },
  {
    id: 6,
    name: "Edwin Lovera",
    first_name: "Edwin",
    last_name: "Lovera",
    community: {
      id: 6,
      name: "Alista",
    },
    status: "Completed",
    screening_type: "Standard",
    autoscore: "decline",
    created: "Nov 15, 2023",
  },
];

